import React, { PropTypes } from 'react';
import { TextField } from 'material-ui';
import FlatButton from '../../../tc-ui/flat-button-with-loader';
import StepperActions from '../../generic-components/stepper-actions';
import R from 'ramda';
import pluralize from 'pluralize';

const ManageRatePackage = ({
  onRequestClose,
  contractId,
  data,
  onTextFieldChangeWithKeyPath,
  manageRatePackage,
  productId,
  ratePackageIndex,
  saving,
  productType,
}, { router }) => {
  const enteredNewPackageName = Boolean(data.newRatePackageName && data.newRatePackageName.trim());
  const allPackageNames = R.call(R.compose(
    existingNames => {
      if (enteredNewPackageName) return R.append(data.newRatePackageName.trim(), existingNames);
      return existingNames;
    },
    R.map(prod => (prod.ratePackageName || '').trim())
  ), data.existingPackagesForProduct);
  const duplicateRatePackage = allPackageNames.length > R.uniq(allPackageNames).length;
  const containInvalidSymbols = allPackageNames.some(name => R.contains('/', name));
  return (
    <div>
      <div style={{ padding: '32px 32px 0 32px', fontSize: '13px' }}>
        {
          productType === 'Accommodation' ? `Rate packages allow you to offer different types of rates for one room type. For example, you can have Room Only, Bed & Breakfast, and Full Room & Board rates for the same room type.`
            : `Rate packages allow you to offer different types of rates for one product. For example, you can have an English rate package and a French rate package for the same product.`
        }
      </div>
      <div style={{ padding: '32px' }}>
        You can modify the existing rate {pluralize('package', data.existingPackagesForProduct.length)}:
        <br/>
        <br/>
        {
          data.existingPackagesForProduct.map((prod, i) => {
            return (
              <div key={i}>
                <div style={{ fontWeight: 'bold' }}>Rate Package {i + 1}</div>
                <TextField
                  style={{ display: 'inline-block' }}
                  id={`existingPackageForProduct${i}`}
                  errorText={!prod.ratePackageName ? `Can't be empty` : ''}
                  hintText="Type here..."
                  value={prod.ratePackageName || ''}
                  onChange={(_, val) => {
                    if (!data.editedExisting) onTextFieldChangeWithKeyPath({ keyPath: ['data', 'editedExisting'], value: true });
                    onTextFieldChangeWithKeyPath({ keyPath: ['data', 'existingPackagesForProduct', i, 'ratePackageName'], value: val });
                  }}
                />
              </div>
            );
          })
        }
        <br/>
        <br/>
        Please enter the name for the new package below:
        <br/>
        <br/>
        <div style={{ fontWeight: 'bold' }}>Rate Package {data.existingPackagesForProduct.length + 1}</div>
        <TextField
          id="newRatePackage"
          hintText="Type here..."
          value={data.newRatePackageName || ''}
          onChange={(_, val) => onTextFieldChangeWithKeyPath({ keyPath: ['data', 'newRatePackageName'], value: val })}
        />
        {
          data.title.indexOf('Create Rate Package') > -1 ? <small style={{ color: 'red' }}> * Required</small> : <small/>
        }
        {
          enteredNewPackageName && duplicateRatePackage ? <div style={{ color: 'red' }}>Please do not create duplicate rate package.</div> : <div/>
        }
        {
          containInvalidSymbols ? <div style={{ color: 'red' }}>Name cannot have "/".</div> : <div/>
        }
      </div>
      <StepperActions
        rightButtons={
          (
            <div>
              <FlatButton labelStyle={{ fontWeight: '600' }} label="Cancel" primary onTouchTap={onRequestClose} />
              <FlatButton
                label="Save Changes"
                onTouchTap={() => {
                  manageRatePackage(contractId, data.productId, data)
                    .then((res) => {
                      if (data.newRatePackageName) {
                        router.replace(`/contracting/draft/${contractId}/product/${data.productId}/${
                          res.payload.newRatePackage ? res.payload.newRatePackage._id : encodeURIComponent(data.newRatePackageName)
                        }`);
                      } else if (ratePackageIndex === data.ratePackageIndex) {
                        const thisPackageId = data.existingPackagesForProduct.find(prod => prod.ratePackageIndex === ratePackageIndex)._id;
                        router.replace(`/contracting/draft/${contractId}/product/${productId}/${thisPackageId}`);
                      }
                    });
                }}
                disabled={(() => {
                  if (containInvalidSymbols) return true;
                  if (enteredNewPackageName && duplicateRatePackage) return true;
                  if (data.existingPackagesForProduct.some(prod => !prod.ratePackageName)) return true;
                  if (data.title.indexOf('Create Rate Package') > -1) {
                    if (!enteredNewPackageName) return true;
                    return saving;
                  }
                  if (!(data.editedExisting || enteredNewPackageName)) return true;
                  return saving;
                })()}
                secondary
                labelStyle={{ fontWeight: '600' }}
              />
            </div>
          )
        }
      />
    </div>
  );
};

ManageRatePackage.propTypes = {
  onRequestClose: PropTypes.func,
  contractId: PropTypes.string,
  data: PropTypes.object,
  productType: PropTypes.string,
};
ManageRatePackage.contextTypes = {
  router: PropTypes.object.isRequired,
};
export default ManageRatePackage;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/add-edit-dialog-content/create-rate-packages.jsx